export function Skeleton({
  className = "",
  height = 12,
  width,
}: {
  className?: string;
  height?: number;
  width?: number | string;
}) {
  const w = typeof width === "number" ? `${width}px` : width;
  return (
    <span
      className={`skeleton inline-block ${className}`}
      style={{ height, width: w ?? "100%" }}
      aria-hidden
    />
  );
}

export function RowSkeleton({ cols = 5 }: { cols?: number }) {
  return (
    <tr className="border-t border-white/5">
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} className="py-3 px-4">
          <Skeleton height={12} width={i === 0 ? "60%" : "40%"} />
        </td>
      ))}
    </tr>
  );
}
